<template>
    <div class="px-4 py-8 sm:px-6 md:py-12 lg:px-16">
        <h2 class="text-3xl sm:text-[40px] font-[900] mb-6 capitalize text-left">Sandesh</h2>
        <div v-if="groupedSandeshItemsByYear.length > 0">
            <div v-for="group in groupedSandeshItemsByYear" :key="group.year" class="mb-4 border border-gray-200 rounded-lg overflow-hidden">
                <button @click="toggleYear(group.year)" 
                        class="w-full flex justify-between items-center p-4 bg-gray-50 hover:bg-gray-100 focus:outline-none">
                    <h3 class="text-xl sm:text-[24px] font-[700] text-[#00395a]">{{ group.year }}</h3>
                    <span class="text-xl text-[#00395a] transition-transform duration-300" 
                          :class="{'rotate-180': expandedYear === group.year}">▼</span>
                </button>
                <div v-show="expandedYear === group.year" class="p-4 border-t border-gray-200">
                    <div class="space-y-6">
                    <div v-for="(item, index) in group.items" :key="index"
                         class="flex flex-col sm:flex-row items-start sm:items-center justify-between group pb-4"
                         :class="{'border-b border-gray-200': index < group.items.length - 1}">
                        <div class="flex-grow mb-2 sm:mb-0">
                            <a :href="item.linkMedia" target="_blank" rel="noopener noreferrer" 
                               class="text-[#00395a] group-hover:underline font-[900] text-xl sm:text-2xl cursor-pointer">
                                {{ item.linkName }}
                            </a>
                        </div>
                        <a :href="item.linkMedia" target="_blank" rel="noopener noreferrer"
                           class="mt-2 sm:mt-0 sm:ml-4 flex items-center text-[#00395a] hover:text-[#002a3c] cursor-pointer">
                            <span class="mr-2 hidden sm:inline">View PDF</span>
                            <img src="./../../assets/external-link.svg" alt="Open PDF" class="w-5 h-5">
                        </a>
                    </div>
                </div>
            </div>
        </div>
       
        </div>
        <div v-else class="text-center text-gray-500">
            <p class="text-lg">No Sandesh items available at the moment.</p>
        </div>
    </div>
</template>
<script>
export default {
  name: 'HomeSandesh',
  props: {
    sandeshItems: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      expandedYear: null, // Tracks which year is currently expanded
      // sandeshItems: [
      //   { name: 'Monthly Newsletter - January 2024', date: '2024-01-15', pdfUrl: '/sandesh/january-2024.pdf', description: 'Highlights from January including community events and updates.' },
      //   { name: 'Special Edition: Diwali Greetings', date: '2023-11-10', pdfUrl: '/sandesh/diwali-2023.pdf' },
      //   { name: 'Community Updates - December 2023', date: '2023-12-20', pdfUrl: '/sandesh/december-2023.pdf' },
      //   { name: 'Annual Report Summary 2023', date: '2024-02-01', pdfUrl: '/sandesh/annual-report-2023.pdf' },
      //   { name: 'Annual Report Summary 2023', date: '2025-02-01', pdfUrl: '/sandesh/annual-report-2023.pdf' },
      //   { name: 'Annual Report Summary 2023', date: '2025-07-01', pdfUrl: '/sandesh/annual-report-2023.pdf' },
      //   { name: 'Annual Report Summary 2023', date: '2026-02-01', pdfUrl: '/sandesh/annual-report-2023.pdf' }
      // ]
      // Additional data properties can be added here if needed
    };
  },
  computed: {
    groupedSandeshItemsByYear() {
      if (!this.sandeshItems || this.sandeshItems.length === 0) {
        return [];
      }

      // Sort all items by date descending (newest first)
      const sortedItems = [...this.sandeshItems].sort((a, b) => new Date(b.linkDate) - new Date(a.linkDate));

      const groups = sortedItems.reduce((acc, item) => {
        const year = new Date(item.linkDate).getFullYear().toString();
        if (!acc[year]) {
          acc[year] = [];
        }
        acc[year].push(item);
        return acc;
      }, {});

      // Convert to array of { year, items } and sort years descending
      return Object.keys(groups)
        .sort((a, b) => parseInt(b, 10) - parseInt(a, 10)) // Sort years numerically, descending
        .map(year => ({
          year: year,
          items: groups[year] // Items within the year are already sorted
        }));
    },
  },
  watch: {
    groupedSandeshItemsByYear: {
        handler(newGroups) {
            // Automatically expand the first (most recent) year if not already set
            if (newGroups.length === 0) {
                // If no items, reset expandedYear
                this.expandedYear = null;
            } else if (this.expandedYear === null) {
                this.expandedYear = newGroups[0].year;
            }
        },
        immediate: true // Run on component mount
    }
  },
  methods: {
    getFormattedDate(dateString) {
      if (!dateString) return '';
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString('en-US', options);
    },
    toggleYear(year) {
      this.expandedYear = this.expandedYear === year ? null : year;
    }
  }
};
</script>
